import React from 'react';
import styles from './AddressCell.module.scss';
import type { Location } from '../../types';

interface AddressCellProps {
  location: Location;
}

export function AddressCell({ location }: AddressCellProps) {
  return (
    <td className={styles.cell}>
      <div className={styles.name}>{location.name}</div>
      <div className={styles.address}>{location.address}</div>
    </td>
  );
}
